/**
 * Created by Vladislav on 05.12.2024.
 */

const MinimalDialogueDebug = function (minimal) { 
    minimal.addCleaner(this.hide.bind(this));

    this.minimal = minimal;
    this.rects = minimal.listRects();
    this.currentNodes = [];
    this.variants = [];
    this.pickedVariant = undefined;

    this.addVariants(minimal.variants);
    this.setPickedVariant(minimal.pickedVariant);

    this.currentStep = this.variants.indexOf(this.pickedVariant);
    this.drawCurrentStep();

    // Use HTML5 events directly for debug UI
    this.onKeyDown = (event) => {
        if (event.code === "ArrowRight") {
            if (this.currentStep < this.variants.length - 1) {
                this.currentStep++;
                this.drawCurrentStep();
            }
        }
        if (event.code === "ArrowLeft") {
            if (this.currentStep > 0) {
                this.currentStep--;
                this.drawCurrentStep();
            }
        }
    };
    document.addEventListener("keydown", this.onKeyDown);
};

MinimalDialogueDebug.prototype.addVariants = function (variants) {
    this.variants = this.variants.concat(variants);
};

MinimalDialogueDebug.prototype.setPickedVariant = function (pickedVariant) {
    this.pickedVariant = pickedVariant;
};

MinimalDialogueDebug.prototype.drawCurrentStep = function () {
    this.clearCurrentStep();

    const step = this.variants[this.currentStep];

    this.rects.forEach(function (rect) {
        this.currentNodes.push(this.drawRect(rect, new cc.Color(0, 0, 255, 255)));
    }, this);

    step.dialogueRects.forEach(function (rect) {
        const color = step.intersection && step.intersection.rect ? new cc.Color(255, 0, 0, 255) : new cc.Color(0, 255, 0, 255);
        this.currentNodes.push(this.drawRect(rect, color));
    }, this);

    if (step.intersection && step.intersection.rect) {
        this.currentNodes.push(this.drawRect(step.intersection.rect, new cc.Color(255, 0, 0, 255), new cc.Color(255, 0, 0, 255)));
    }
};

MinimalDialogueDebug.prototype.clearCurrentStep = function () {
    this.currentNodes.forEach((node) => {
        node.removeFromParent();
    });

    this.currentNodes = [];
};

MinimalDialogueDebug.prototype.drawRect = function (rect, color, fillColor) {
    fillColor = fillColor || new cc.Color(0, 0, 0, 0);

    const node = new cc.DrawNode();
    node.setAnchorPoint(0, 0);
    node.setContentSize2(rect.width, rect.height);
    node.setAlignment(rect.x, rect.y);
    node.drawRect(cc.p(0, 0), cc.p(rect.width, rect.height), fillColor, 3, color);
    node.setLocalZOrder(1000);
    cleverapps.Scenes.GetRunningScene().addChild(node);

    return node;
};

MinimalDialogueDebug.prototype.hide = function () {
    document.removeEventListener("keydown", this.onKeyDown);
    delete this.onKeyDown;

    this.clearCurrentStep();
};

MinimalDialogueDebug.create = function (minimal) {
    const debugInfo = new MinimalDialogueDebug(minimal);

    cleverapps.flags.on("change:debugMinimal", () => {
        debugInfo.hide();
    }, minimal);
};

MinimalDialogueDebug.initialize = function () {
    cleverapps.flags.on("change:debugMinimal", () => {
        const minimal = MinimalDialogue.current;

        if (minimal) {
            if (cleverapps.flags.debugMinimal) {
                MinimalDialogueDebug.create(minimal);
            } else if (minimal.debugMinimal) {
                minimal.debugMinimal.hide();
                delete minimal.debugMinimal;
            }
        }
    });
};